import { StyleSheet } from "react-native";
import colors from "@constants/color";
import metrics from "@constants/metrics";

export const styles = StyleSheet.create({
  headContainer: {
    backgroundColor: "#F6F7F9",
  },
  beLikeRow: {
    flexDirection: "row",
    alignItems: "center",
  },
  passbookViewContainer: {
    paddingVertical: 10,
  },
  passbookItemContainer: {
    width: metrics.screenWidth * 0.95,
    backgroundColor: colors.white,
    marginBottom: 10,
    borderRadius: 10,
    padding: 10,
  },
  loaderContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  itemHeaderContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  mainHeader: {
    flexDirection: "row",
    alignItems: "center",
  },
  verticalSeperator: {
    height: 12,
    width: 1,
    backgroundColor: colors.lightBlack,
    marginHorizontal: 5,
  },
  itemBodyContainer: {
    flexDirection: "row",
  },
  itemContentContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  salesPriceContainer: {
    flexDirection: "column",
    padding: 10,
  },
  passbookBody: {
    width: "70%",
  },
  passbookPriceStatus: {
    width: "30%",
    justifyContent: "center",
    alignItems: "center",
  },
  caretContainer: {
    marginLeft: 5,
  },
  rowContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
});
